import React from 'react';
import ProfileSection from '../components/about/ProfileSection';

const About: React.FC = () => {
  return (
    <>
      <ProfileSection />
    </>
  );
};

export default About;